<template>
    <el-dialog
        :visible="visible"
        class="receipt-upload-input-photo-upload-dialog ah-detail-dialog"
        top="4vh"
        :before-close="onClose"
        :lock-scroll="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        @open="onOpen"
    >
        <template slot="title">
            <div>上傳圖片</div>
        </template>
        <div class="detail-row">
            <div v-if="isLoadingImg" class="detail-block">
                <el-table v-loading="true" />
            </div>
            <div v-show="!isLoadingImg" class="detail-block">
                <div class="img-cropper" style="max-width: 450px; margin: 0 auto">
                    <vue-cropper
                        :zoomOnWheel="false"
                        ref="cropper"
                        :src="imgSrc"
                        :autoCropArea="1"
                        :minCropBoxWidth="50"
                        :minCropBoxHeight="50"
                        :img-style="screenHeight > 570 ? {} : { 'max-height': `${screenHeight}px` }"
                        preview=".preview"
                    />
                </div>
                <div id="receipt-qrcode" style="opacity: 0; width: 1000px; position: absolute"></div>
                <canvas id="qrcode-canvas" style="display: none"></canvas>
                <center style="margin-top: 15px">
                    <el-button @click="rotateImg(-90)" icon="el-icon-refresh-left"></el-button>
                    <el-button @click="rotateImg(90)" icon="el-icon-refresh-right"></el-button>
                    <!-- <el-button @click="onClose">取消</el-button> -->
                    <el-button @click="$emit('reupload')">更換檔案</el-button>
                    <el-button type="primary" :loading="isLoading" @click="onNext">
                        下一步
                    </el-button>
                </center>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import VueCropper from 'vue-cropperjs';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cropperjs/dist/cropper.css';
import axios from 'axios';
import moment from 'moment';
import { Html5Qrcode } from 'html5-qrcode';

export default {
    props: {
        visible: Boolean,
        file: {
            type: File,
            default: null,
        },
        quality: {
            type: Number,
            default: 0.7,
        },
        maxWidth: {
            type: Number,
            default: 1280,
        },
        maxHeight: {
            type: Number,
            default: 1280,
        },
        watermark: {
            type: String,
            default: '',
        },
        noUpload: Boolean,
        rotateBtn: Boolean,
        fileInfo: Boolean,
    },
    components: { VueCropper },
    computed: {
        screenHeight() {
            return (window.innerHeight / 3) * 2;
        },
    },
    watch: {
        file(val) {
            if (val) this.onSetImage(this.file);
        },
    },
    data() {
        return {
            isLoadingImg: false,
            isLoading: false,
            imgSrc: null,

            qrData: {
                foo: null,
                foO_DAT: null,
                filE_TYP: 0,
                bsn: null,
                amt: null,
                tax: null,
            },
        };
    },
    methods: {
        onOpen() {
            this.onSetImage(this.file);

            setTimeout(() => {
                this.scanQrcode(this.file);
            }, 500);
        },
        onClose() {
            this.isLoadingImg = false;
            this.isLoading = false;
            this.imgSrc = null;
            this.qrData = {
                foo: null,
                foO_DAT: null,
                filE_TYP: 0,
                bsn: null,
                amt: null,
                tax: null,
            };
            this.$emit('close');
        },
        onNext() {
            this.onUpload();
        },
        async onUpload() {
            this.isLoading = true;

            // get image data
            const canvas = this.$refs.cropper.getCroppedCanvas({
                maxWidth: this.maxWidth,
                maxHeight: this.maxHeight,
            });

            // 添加浮水印
            if (this.watermark.trim() !== '') {
                this.drawWatermark(canvas, this.watermark.trim());
            }

            const imgData = canvas.toDataURL('image/jpeg', this.quality);

            // formData
            const formData = new FormData();
            formData.append('uploadType', 1);
            formData.append('file', this.dataURLtoFile(imgData));

            // ajax post
            try {
                const resp = this.noUpload ? { data: { imgUrl: `${imgData}.jpeg` } } : await this.uploadImg(formData);
                this.$emit('change', {
                    ...this.qrData,
                    filE_ATT: resp.data.imgUrl,
                    formData: this.noUpload ? formData : null,
                    fileInfo: this.fileInfo ? this.file : null,
                });
                this.onClose();
            } catch (e) {
                console.log(e);
                this.$message({
                    showClose: true,
                    message: '上傳失敗，請重新上傳。',
                    type: 'error',
                });
            } finally {
                this.isLoading = false;
            }
        },
        async uploadImg(formData) {
            return axios.post(`${process.env.VUE_APP_API_PATH}Tool/UploadImg`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
        },
        drawWatermark(canvas, watermarkTxt) {
            // 計算出 canvas 對角線角度、長度
            const ctx = canvas.getContext('2d');
            const angle = Math.atan(canvas.width / canvas.height) - ((Math.PI / 180) * 90); // 角度
            const diagonalWidth = canvas.width * Math.cos(angle); // 對角線長度

            // 設定文字樣式
            ctx.fillStyle = 'rgba(0, 0, 0, 0.2)';
            ctx.font = '30px Arial';
            const textWidth = ctx.measureText(watermarkTxt).width;

            // 計算文字長度（重複次數）
            const textRepeat = Math.ceil(diagonalWidth / textWidth);
            let watermark = watermarkTxt;
            for (let i = 0; i < textRepeat; i += 1) {
                watermark += ` ${watermarkTxt}`;
            }

            // 移動到左下角、繪製
            ctx.translate(10, canvas.height);
            ctx.rotate(angle);
            ctx.fillText(watermark, 0, 0);
        },
        scanQrcode(imgFile) {
            // 因掃描只能辨識一個qrcode，所以須先將右邊遮掉
            const qrarea = document.getElementById('receipt-qrcode');

            const cav = document.getElementById('qrcode-canvas');
            const ctx = cav.getContext('2d');

            const img = new Image();
            img.onload = () => {
                // 載入圖片
                cav.width = img.width;
                cav.height = img.height;
                ctx.drawImage(img, 0, 0);

                // 遮掉右半邊
                const helfWidth = img.width / 2;
                ctx.rect(helfWidth, 0, helfWidth, img.height);
                ctx.fillStyle = 'black';
                ctx.fill();

                fetch(cav.toDataURL())
                    .then((res) => res.blob())
                    .then((blob) => {
                        const file = new File([blob], 'dot.png', blob);
                        console.log(file);

                        // 開始辨識
                        qrarea.style.display = 'block';
                        const html5QrCode = new Html5Qrcode('receipt-qrcode');
                        html5QrCode
                            .scanFile(file, true)
                            .then((decodedText) => {
                                console.log(decodedText);
                                this.applyQrcodeInfo(decodedText);
                            })
                            .catch((err) => {
                                console.log(`Error scanning file. Reason: ${err}`);
                            })
                            .finally(() => {
                                qrarea.style.display = 'none';
                            });
                    });
            };
            img.src = URL.createObjectURL(imgFile);
        },
        applyQrcodeInfo(code) {
            // 發票號碼
            const foo = code.substring(0, 10);
            console.log('foo', foo);

            // 開立日期
            const year = parseInt(code.substring(10, 13), 10) + 1911;
            const month = parseInt(code.substring(13, 15), 10);
            const date = parseInt(code.substring(15, 17), 10);
            console.log('year', year);
            console.log('month', month);
            console.log('date', date);
            const fooDate = moment(`${year}-${month}-${date}`)
                .startOf('day')
                .format('x');

            // 稅金
            const noTaxPrice = parseInt(code.substring(21, 29), 16);
            const amt = parseInt(code.substring(29, 37), 16);
            let tax = 0;
            if (noTaxPrice > 0) tax = amt - noTaxPrice;
            console.log('tax', tax);
            console.log('amt', amt);

            // 賣方統編
            const bsn = code.substring(45, 53);
            console.log('bsn', bsn);

            // 買方統編
            const buyerBsn = code.substring(37, 45);
            console.log('buyerBsn', buyerBsn);

            this.qrData = {
                foo,
                foO_DAT: Number(fooDate),
                filE_TYP: 1,
                bsn,
                buyerBsn,
                amt,
                tax,
            };
        },
        onSetImage(file) {
            this.isLoadingImg = true;

            if (file.type.indexOf('image/') === -1) {
                alert('Please select an image file');
                return;
            }
            if (typeof FileReader === 'function') {
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.imgSrc = event.target.result;
                    // rebuild cropperjs with the updated source
                    this.$refs.cropper.replace(event.target.result);
                    this.isLoadingImg = false;
                };
                reader.readAsDataURL(file);
            } else {
                alert('Sorry, FileReader API not supported');
            }
        },
        dataURLtoFile(dataurl, filename) {
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n) {
                u8arr[n - 1] = bstr.charCodeAt(n - 1);
                n -= 1; // to make eslint happy
            }
            return new File([u8arr], filename, { type: mime });
        },
        rotateImg(deg) {
            this.$refs.cropper.rotate(deg);
        },
    },
};
</script>

<style lang="scss">
.cropper-crop-box {
    @media (max-width: 720px) {
        $pointSize: 25px;
        $helfPointSize: 12px;

        .cropper-point {
            width: $pointSize;
            height: $pointSize;
        }
        .cropper-point.point-e,
        .cropper-point.point-w {
            margin-top: -$helfPointSize;
        }

        .cropper-point.point-n,
        .cropper-point.point-s {
            margin-left: -$helfPointSize;
        }
    }
}
</style>
